import { IPlannedPortfolio } from 'src/app/models/plannedPortfolios';
import { IFailedTempPlannedPortfolio, IPlannedPortfolioRebalancedState } from './../../../models/plannedPortfolios';
import { IModelPortfolio } from 'src/app/models/modelPortfolios';
import { IModelPortfolioSubmitState } from './../../../models/modelPortfolios';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IAppState } from '../../state/app.state';
import { IModelPortfoliosState } from '../../state/model-portfolios.state';
import { Features } from 'src/app/models/features';
import { createEntityAdapter } from '@ngrx/entity';

export const getModelPortfoliosState = createFeatureSelector<IAppState, IModelPortfoliosState>(Features.MODEL_PORTFOLIOS);

export const modelPortfolioAdapter = createEntityAdapter<IModelPortfolio>({
    selectId: (modelPortfolio: IModelPortfolio) => modelPortfolio.id
});

export const {
    selectAll: selectAllModelPortfolios,
    selectEntities: selectModelPortfolios
} = modelPortfolioAdapter.getSelectors(getModelPortfoliosState);

export const selectModelPortfolioSubmittedFail = createSelector(
    getModelPortfoliosState,
    (state: IModelPortfoliosState) => state.modelPortfolioSubmittedFail
);
export const selectModelPortfolioLoading = createSelector(
    getModelPortfoliosState,
    (state: IModelPortfoliosState) => state.loading
);
export const modelPortfolioSubmittedSuccess = createSelector(
    getModelPortfoliosState,
    (state: IModelPortfoliosState) => state.modelPortfolioSubmittedSuccess
);
export const getSelectedModelportfolio = createSelector(
    getModelPortfoliosState,
    (state: IModelPortfoliosState) => {
        const modelPortfolio = {
            ...state.entities[state.selectedModelPortfolioId]
        };
        return modelPortfolio;
    }
);
export const selectFailedTempPlannedPortfolios = createSelector(
    getModelPortfoliosState,
    (state: IModelPortfoliosState) => {
        return state.failedTempPlannedPortfolios;
    }
);
export const selectRebalancedPlannedPortfolios = createSelector(
    getModelPortfoliosState,
    (state: IModelPortfoliosState) => {
        return state.rebalancedPlannedPortfolios;
    }
);
export const selectselectedTempPlannedPortfolio = createSelector(
    getModelPortfoliosState,
    (state: IModelPortfoliosState) => {
        return state.selectedTempPlannedPortfolio;
    }
);
export const getLastSavedModelPortfolio = createSelector(
    getModelPortfoliosState,
    (state: IModelPortfoliosState) => {
        const lastSavedMP: IModelPortfolio = {
            ...state.lastSavedModelPortfolio
        };
        return lastSavedMP;
    }
);
export const getLastSubmittedModelPortfolioId = createSelector(
    getModelPortfoliosState,
    (state: IModelPortfoliosState) => {
        return state.lastSubmittedModelPortfolioId;
    }
);
export const selectedIsModelPortfolioUpdated = createSelector(
    getModelPortfoliosState,
    (state: IModelPortfoliosState) => state.isModelPortfolioUpdated
);
export const selectedPlannedPortfolio = createSelector(
    getModelPortfoliosState,
    (state: IModelPortfoliosState) => state.plannedPortfolios[0]
);
export const selectModelPortfolioName = createSelector(
    getModelPortfoliosState,
    (state: IModelPortfoliosState) => {
        const selectedModelPortfolio = state.entities[state.selectedModelPortfolioId];
        if (selectedModelPortfolio) {
            return selectedModelPortfolio.name;
        } else {
            return "";
        }
    }
);
export const selectIsLoading = createSelector(
    getModelPortfoliosState,
    (state: IModelPortfoliosState) => state.loading
);
export const selectModelPortfolioSubmittedSuccess = createSelector(
    getModelPortfoliosState,
    (state: IModelPortfoliosState) => state.modelPortfolioSubmittedSuccess
);
export const selectModelPortfolioDeletedSuccess = createSelector(
    getModelPortfoliosState,
    (state: IModelPortfoliosState) => {
        return{
            modelPortfolioDeletedSuccess: state.modelPortfolioDeletedSuccess,
            modelPortfolioDeletedSuccessText: state.modelPortfolioDeletedSuccessText
        };
    }
);
export const selectModelPortfolioPositionDeletedSuccess = createSelector(
    getModelPortfoliosState,
    (state: IModelPortfoliosState) => {
        return {
            modelPortfolioPositionDeletedSuccess: state.modelPortfolioPositionDeletedSuccess,
            modelPortfolioPositionDeletedSuccessText: state.modelPortfolioPositionDeletedSuccessText
        };
    }
);
export const selectModelPortfolioSubmitState = createSelector(
    getModelPortfoliosState,
    (state: IModelPortfoliosState): IModelPortfolioSubmitState => {
        return {
            modelPortfolioSubmittedSuccess: state.modelPortfolioSubmittedSuccess,
            loading: state.loading,
            modelPortfolioSubmittedSuccessText: state.modelPortfolioSubmittedSuccessText,
            submittedModelPortfolio: state.submittedModelPortfolio
        };
    }
);
export const selectIsModelPortfolioInitialState = createSelector(
    getModelPortfoliosState,
    (state: IModelPortfoliosState): boolean => state.isInitialState
);
export const selectLoadingModelPortfolio = createSelector(
    getModelPortfoliosState,
    (state: IModelPortfoliosState) => state.loading
);

export const selectModelPortfolioOrders = createSelector(
    getModelPortfoliosState,
    (state: IModelPortfoliosState) => state.modelPortfoliosOrders
);

export const selectSubscriberCashSummaries = createSelector(
    getModelPortfoliosState,
    (state: IModelPortfoliosState) => state.subscriberCashSummaries
);
